const paystackUrl = "https://api.paystack.co/"

export { paystackUrl }
